import toast from "react-hot-toast";
import { GetProviderList } from "./Service";
import { GetPatientDetails } from "../patientDetail/Service";


export function GragIntakeSheetData(hippaAuthData) {
  let row = [];
  for (let i = 0; i < hippaAuthData?.notesdata.length; i++) {
    if (hippaAuthData?.notesdata[i].ApplicationValue) {
      for (let j = 0; j < hippaAuthData.notesdata[i].ApplicationValue.length; j++) {
        let data = {};
        data.Name = hippaAuthData.notesdata[i].ApplicationValue[j].Name;
        data.Type = hippaAuthData.notesdata[i].ApplicationValue[j].Type;
        data.Value = hippaAuthData.notesdata[i].ApplicationValue[j].Value;
        data.isRender = hippaAuthData.notesdata[i].ApplicationValue[j].isRender;
        data.RenderKeyName = hippaAuthData.notesdata[i].RenderKeyName;
        row.push(data);
      }
    }
  }
  return row;
}

export function GragIntakeFormData(intakeForm) {
  let row = [];
  for (let i = 0; i < intakeForm?.length; i++) {
    let data = {};
    data.Name = intakeForm[i].Name;
    data.Type = intakeForm[i].Type;
    data.Value = intakeForm[i].Value;
    data.isRender = intakeForm[i].isRender;
    data.RenderKeyName = intakeForm[i].RenderKeyName;
    row.push(data);
  }
  return row;
}


export async function CallApiForProviderList(companyId, providerId) {
  try{
      const result = await GetProviderList(companyId)
      if (result?.length > 0) {
         const providerData = result?.find(x => x.ProviderId === providerId) || {};
         return providerData;
      } else {   
      console.error('Something went wrong')
        return {};
      }
    }catch (error) {
      console.error(error?.Message)
      return {}
    }
}


export async function GetValueForIntakeSheet(props, selectedData) {
  let data = "";
  // let SessionData = GetSessionData();
  // let TokenInfo = GetTokenInfo();
  // let companyId = props.selectedRow.searchResult ? props.selectedRow.searchResult.Patient.Account.ID : props.selectedRow.data.Account.ID;

  // let doctorId = SessionData.Physician.ID;

  // let caseId = props.selectedRow.searchResult ? props.selectedRow.searchResult.Patient.CaseID : props.selectedRow.data.CaseID;

  // const requestBody = JSON.stringify({
  //   CaseFormDataId: null,
  //   CompanyId: companyId,
  //   DoctorId: doctorId,
  //   FormName: selectedData.selectedData[0].FormName,
  //   FormId: selectedData.selectedData[0].FormId,
  //   TemplateName: selectedData.selectedData[0].TemplateName,
  //   EntityLevel: selectedData.selectedData[0].EntityLevel,
  //   FormType: selectedData.selectedData[0].FormType,
  //   IsFormCompleted: selectedData.selectedData[0].IsFormCompleted,
  //   JsonData: selectedData.selectedData[0].JsonData,
  //   CaseId: caseId,
  //   UserId: SessionData.ID,
  // });

  // await fetch(props.BaseUrl + "GenericForm/CaseFormListData", {
  //   method: "post",
  //   headers: {
  //     Accept: "application/json",
  //     "Content-Type": "application/json",
  //     Authorization: "Bearer " + TokenInfo.AccessToken,
  //   },
  //   body: requestBody,
  // })
  //   .then((Response) => {
  //     if (Response.status === 401) {
  //       data = "";
  //       return data;
  //     }
  //     return Response.json();
  //   })
  //   .then((result) => {
  //     data = result;
  //     return data;
  //   });
  return data;
}

export const handleGetPatientDetails = async (caseId, companyId) => {
    try {
      //   setLoading(true);
      // const caseId = tokenData?.caseId;
      // const companyId = tokenData?.companyId;
      if (!caseId || !companyId) {
        console.error("Missing caseId or companyId in token data");
        toast.error("Something went wrong while fetching your details.");
        return;
      }
      const response = await GetPatientDetails(caseId, companyId);
      if (response.success) {
        const details = response.data;
        if (details) {
          // setPatientData(details);
          // setPatientName(details.patientFirstName + details.patientLastName);
          return details;
        } else {
          console.error("Patient details not found in response");
          toast.error("Something went wrong while fetching your details.");
          return {};
        }
      } else {
        console.error("API error:", response.message);
        toast.error("Something went wrong while fetching your details.");
        return {};
      }
    } catch (error) {
      console.error("Error fetching patient details:", error);
      toast.error("Something went wrong while fetching your details.");
      return {};
    } finally {
      //   setLoading(false);
    }
  };